import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { style: {"float":"left"} }
const _hoisted_2 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"} }

import { ref, reactive, onMounted, unref } from 'vue';
import { ElForm, ElMessage } from 'element-plus';

/* Apis */
import { GetTempSelectApi } from '../../../apis/ct_templates/templates.api';

/* Types */
import { CreateByTemplateDto } from '../../../apis/contract/contract.dto'

interface SelectDto {
    id: string
    code: string
    name: string
}

/* 验证规则 */

export default /*#__PURE__*/_defineComponent({
  emits: ['register'],
  setup(__props, { expose, emit: $emits }) {



const formRules = {
    template_Id: [{ required: true, message: '请选择合同模板', trigger: 'change' }],
    name: [{ required: true, message: '合同名称不能为空', trigger: 'change' }],
}

/* 表单数据 */
const formSchema = ref<CreateByTemplateDto>({
    template_Id: '',
    name: ''
})

const searchKey = ref<string>('')

const loading = ref<boolean>(false)

const selectList = ref<SelectDto[]>([])

const elFormRef = ref<ComponentRef<typeof ElForm>>()

/* 获取模板列表 */
const getTemplateList = (keys: string) => {

    loading.value = true

    GetTempSelectApi(keys)
        .then(res => {

            if (!res.succeeded) {

                ElMessage.error(`获取模板列表失败，可能的原因是：${res.errors}`)

            } else {

                selectList.value = res.data || []

            }

        })
        .finally(() => {
            loading.value = false
        })
}

/* 外部调用的属性或方法 */
const funcs = {

    getLoadStatus: (): boolean => {

        return unref(loading)

    },

    /* 设置读取状态 */
    setLoadStatus: (isLoad: boolean) => {

        loading.value = isLoad

    },

    /* 获取表单数据 */
    getFormData: () => {

        return unref(formSchema);

    },

    /* 设置表单数据 */
    setFormData: (data: any): void => {

        formSchema.value = Object.assign(unref(formSchema), data)

    }
}

expose({ funcs })

onMounted(() => {

    $emits('register', unref(elFormRef)?.$parent, unref(elFormRef))

    getTemplateList(unref(searchKey))

})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_unref(ElForm), {
    ref_key: "elFormRef",
    ref: elFormRef,
    model: formSchema.value,
    rules: formRules,
    "label-position": "right",
    "label-width": "120px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "合同模板",
        prop: "template_Id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: formSchema.value.template_Id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.template_Id) = $event)),
            disabled: selectList.value.length > 0 ? false : true,
            placeholder: "请选择合同模板",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(item.code), 1),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "合同名称",
        prop: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formSchema.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.name) = $event)),
            placeholder: "请输入合同名称"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "合同编号" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formSchema.value.no,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.no) = $event)),
            placeholder: "请输入合同编号，当合同编号为空时，将使用系统编号"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})